import React, { Component, Fragment } from 'react';
import './Tip.module.scss';

class Tip extends Component {

    constructor() {
        super();

        this.state = {
            showTip: false
        };

        this.toggleTip = this.toggleTip.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutsideTip = this.handleClickOutsideTip.bind(this);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutsideTip);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutsideTip);
    }
    /**
       * Set the wrapper ref
       */
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    /**
       * Alert if clicked on outside of element
       */
    handleClickOutsideTip(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target) && event.target.id != 'tip') {
            this.setState({ showTip: false });
        }
    }

    toggleTip() {
        this.setState({ showTip: !this.state.showTip });
    }

    render() {
        return (
            <Fragment>
                <span id='tip' onClick={this.toggleTip}>Tip</span>
                { this.state.showTip &&
                <div ref={this.setWrapperRef} styleName='tip' style={this.props.style}>
                    <img src={this.props.image} />
                    <p>{this.props.tip}</p>
                </div>
                }
            </Fragment>
        );
    }

}

export default Tip;